import { hasSlotContent as e } from "../../common/utils/index.js";
import { t } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { createCommentVNode as n, createElementBlock as r, createElementVNode as i, normalizeClass as a, normalizeStyle as o, openBlock as s, renderSlot as c } from "vue";
//#region components/card/card.vue
var l = {
	compatConfig: { MODE: 3 },
	name: "DtCard",
	props: {
		maxHeight: {
			type: String,
			default: null
		},
		contentClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		headerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		footerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		}
	},
	data() {
		return { hasSlotContent: e };
	}
}, u = {
	class: "d-card",
	"data-qa": "dt-card"
};
function d(e, t, l, d, f, p) {
	return s(), r("div", u, [
		f.hasSlotContent(e.$slots.header) ? (s(), r("div", {
			key: 0,
			class: a(["d-card__header", l.headerClass])
		}, [c(e.$slots, "header")], 2)) : n("", !0),
		i("div", {
			class: a(["d-card__content", l.contentClass]),
			style: o({ "max-height": l.maxHeight })
		}, [c(e.$slots, "content")], 6),
		f.hasSlotContent(e.$slots.footer) ? (s(), r("div", {
			key: 1,
			class: a(["d-card__footer", l.footerClass])
		}, [c(e.$slots, "footer")], 2)) : n("", !0)
	]);
}
var f = /* @__PURE__ */ t(l, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=card.js.map